//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PwrConfirm',
  props: {
    title: {
      type: String,
      default: 'Confirm',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'pwr-confirm',
    },
    okTitle: {
      type: String,
      default: 'Yes',
    },
  },
  methods: {
    show() {
      this.$refs.confirm.show();
    },
    hide() {
      this.$refs.confirm.hide();
    },
  },
};
